import { isISOString } from "./is.iso.string";

export const K_GLOBAL_DEFAULT_OBJECT_ID = "000000000000000000000000";
export const K_GLOBAL_DEFAULT_ISO_STRING_DATE = "0001-01-01T00:00:00.000Z";

export const isValidObjectID = (objID: string) => {
  if (!objID) return false;
  return objID?.length === 24 && objID !== K_GLOBAL_DEFAULT_OBJECT_ID;
};

export const isValidISODate = (isoDate: string) => {
  if (!isoDate) return false;
  return (
    isISOString(isoDate) &&
    !isoDate.startsWith(K_GLOBAL_DEFAULT_ISO_STRING_DATE.substring(0, 16))
  );
};
